import { useEffect } from 'react';
import { useMap } from 'rwl-ui';
import { useGlobal } from './useGlobal';
import { useMapContext } from './MapProvider';

export const useMapEvents = () => {
    const { map } = useMap();
    const { config } = useGlobal();
    const { serviceAreas, neighborhood } = useMapContext();

    useEffect(() => {
        if (map) {
            const zipCodeLayer = map.getFeatureLayer(
                google.maps.FeatureType.POSTAL_CODE
            );

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const handleMouseMove = (event: google.maps.FeatureMouseEvent) => {
                // TODO: For future hover events
            };

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const handleClick = (event: google.maps.FeatureMouseEvent) => {
                // TODO: For future click events to open neighborhood map
            };

            // zipCodeLayer.addListener('mousemove', handleMouseMove);
            // zipCodeLayer.addListener('click', handleClick);

            zipCodeLayer.style = (option) => {
                // @ts-ignore - option.feature.placeId is not recognized
                const placeId = option.feature.placeId;
                const area = serviceAreas?.find(
                    (a) => a.placeInfo?.place_id === placeId
                );
                if (
                    area &&
                    (!neighborhood ||
                        neighborhood.placeInfo?.place_id === placeId)
                ) {
                    const fillColor = config?.account.mapSettings['color']
                        ? config.account.mapSettings['color']
                        : '#3862d7';
                    return {
                        fillColor,
                        fillOpacity: 0.1,
                        strokeWeight: neighborhood ? 2 : 1,
                        strokeColor: '#9E9E9E',
                    };
                }

                return;
            };
        }
    }, [map, serviceAreas, neighborhood]);
};
